import * as React from 'react';

import Alert from '@mui/material/Alert';

import Typography from '@mui/material/Typography';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SearchIcon from '@mui/icons-material/Search';
import LayersIcon from '@mui/icons-material/Layers';
import LayersClearIcon from '@mui/icons-material/LayersClear';
import LinkIcon from '@mui/icons-material/Link';


import { GB, DE } from 'country-flag-icons/react/3x2'

export default function DisclaimerDe() {

	// define GUI elements
	return (
		<React.Fragment>
		{/*
			<Alert severity="warning">
				Diese Vorschau ist <b>nicht verbindlich</b>. 
				Diese Webseite befindet sich im <b>Test-Betrieb</b>. Informationen zu
				Lehrveranstaltungen und Links in das Modulhandbuch können unvollständig sein.
			</Alert>
		*/}
			<Alert severity="info">
				Die Vorschau enthält keine Information zu Seminaren, Fortgeschrittenenpraktika und Projektarbeiten. Beachten Sie hierzu die Nutzungshinweise.
				Angegeben ist jeweils die garantierte Veranstaltungssprache. Insbesondere Aufbau-Module in Deutsch (<DE title="Deutsch" style={{width: '1em'}}/>)
				können möglicherweise auch auf Englisch (<GB title="English" style={{width: '1em'}}/>) studiert werden. Vor allem für Module
				in <DE title="Deutsch" style={{width: '1em'}}/>, die als Auflage vergeben wurden, existiert in der Regel  
				ein <GB title="English" style={{width: '1em'}}/> Angebot. Bei Modulen in <GB title="English" style={{width: '1em'}}/> kann in der Regel die Prüfung auch 
				auf <DE title="Deutsch" style={{width: '1em'}}/> abgelegt werden. Sprechen Sie im Zweifen die Dozentin oder den Dozenten an.
			</Alert>
			<Accordion>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1-content"
					id="panel1-header"
				>
					Nutzungshinweise & Legende
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						Diese Vorschau ist <b>nicht verbindlich</b>.
						Informationen zu den Lehrveranstaltungen des laufenden Semesters
						sind genauer auf MARVIN zu finden. Informationen zu den Lehrveranstaltungen des
						folgenden Semesters finden Sie auf MARVIN ab März (für ein Sommersemester)
						oder September (für ein Wintersemester).
					</Typography>
					<Typography>
						Die Lehrveranstaltungen in dieser Vorschau beinhalten keine Seminare, individuelle Praktika
						("Fortgeschrittenenpraktikum", "Projektarbeit"), "Abschlussarbeiten" und
						das Modul "Selbstständiges wissenschaftliches Arbeiten". Solche Lehrveranstaltungen werden
						dennoch jedes Semester angeboten. Sie sind in dieser Liste nicht enthalten, weil sie
						sie in der Regel kurzfristig angeboten werden. Bitte konsultieren Sie MARVIN für die angebotenen Seminare
						in diesem oder dem kommenden Semester. Für die Praktika besuchen Sie bitte den
						entsprechenden ILIAS-Kurs, um verfügbare Aufgaben zu sehen (neue Aufgaben werden
						in der Regel zu Beginn der Vorlesungszeit bereitgestellt und vergeben, erst dann ist auch ein Beitritt zu dem Kur möglich):
						"ILIAS: Kurse aller Semester" &gt; "Fb. 12: Mathematik und Informatik" &gt; "Informatik" &gt; "Softwaretechnik" &gt; <i>aktuelles Semester</i> &gt; "Taentzer: SO Fortgeschrittenenpraktika und Projektarbeiten".
						Wenn Sie auf der Suche nach einer Aufgabe für eine Abschlussarbeit sind, besuchen Sie bitte die Webseiten
						der Arbeitsgruppen oder wenden Sie sich direkt an die Professorinnen, Professoren, Assistentinnen
						und Assistenten.
					</Typography>
					<Typography>
						Über die Schaltfläche <FilterAltIcon /> können Sie die Gruppierungs- und
						Filtermöglichkeiten nach Ihrem Studiengang und nach den Modulen, die Sie besonders
						interessieren, festlegen. Setzen Sie alle Filter und Gruppierungseinstellungen mit dert Schaltfläche
						<FilterAltOffIcon/> zurück. Mit Hilfe des Suchfeldes (<SearchIcon />) können Sie die angezeigte Vorschau
						schnell auf Kurse reduzieren, bei denen entweder der Titel oder der Dozent/die Dozentin dem
						Suchbegriff entsprechen. Über die Schaltfläche <LayersIcon /> können Sie die Anzeige von Details in der
						Tabelle ausblenden; über <LayersClearIcon /> können Sie diese wieder einblenden. Mit der
						Schaltfläche <LinkIcon /> können Sie einen Link zu der Vorschau in Ihre Zwischenablage kopieren,
						der ihre aktuellen Filtereinstellungen enthält. 
					</Typography>
					<Typography>
						Zu jeder Veranstaltung werden neben dem Namen und den verantwortlichen Dozentinnen und Dozenten
						die folgenden Eigenschaften in eckigen Klammern angezeigt:
						<Typography component='li'>Niveaustufe.</Typography>
						<Typography component='li'>Umfang in Leistungspunkten.</Typography>
						<Typography component='li'>Veranstaltungssprache.</Typography>
						<Typography component='li'>Merkmale (&#129513;), die möglicherweise die wählbarkeit in einem Studienbereich einschränken.
							Die Bedeutung der Merkmnale ist in der Prüfungsordnung Ihres Studiengangs beschrieben.
							Die relevantesten Merkmale sind: 
						  	<Typography component='li'><b>P</b> - Praktische Informatik</Typography>
							<Typography component='li'><b>T</b> - Theoretische Informatik</Typography>
							<Typography component='li'><b>I</b>, <b>Inf</b> - Informatik</Typography>
							<Typography component='li'><b>M</b> - Mathematik</Typography>
							<Typography component='li'><b>A</b> - Angewandte Mathematik (oder Variante A)</Typography>
							<Typography component='li'><b>R</b> - Reine Mathematik</Typography>
							<Typography component='li'><b>gestr</b> - Studiengang in der gestreckten Variante</Typography>
							<Typography component='li'><b>S</b> - Anwendungsgebiet Sprachen</Typography>
							<Typography component='li'><b>GI</b> - Anwendungsgebiet Geoinformatik</Typography>
							<Typography component='li'><b>SW</b> - Anwendungsgebiet Sozialwissenschaften</Typography>
							<Typography component='li'><b>MI</b> - Anwendungsgebiet Medizininformatik</Typography>
					  	</Typography>
						Wenn Sie den Mauszeiger über eine Veranstaltung bewegen oder diese berühren, werden die Eigenschaften
						ausführlicher in einem Tooltip dargestellt. Von dort ist auch das online Modulhandbuch des
						Fachbereichs verlinkt. Sie können so zu dem Modulhandbucheintrag für einen Studiengang, einen
						Studienbereich oder dem Modul (&#128214;) innerhalb des Studienbereichs gelangen.
					</Typography>

				</AccordionDetails>
			</Accordion>
		</React.Fragment>

	);
}